// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.client.userprofile.enums.PropertyCountRangeType

export enum PropertyCountRangeType {
  ELEVEN_TO_FIFTY = 'ELEVEN_TO_FIFTY',
  FIFTY_ONE_TO_TWO_HUNDRED = 'FIFTY_ONE_TO_TWO_HUNDRED',
  ONE = 'ONE',
  TWO_HUNDRED_PLUS = 'TWO_HUNDRED_PLUS',
  TWO_TO_TEN = 'TWO_TO_TEN',
}

export const PropertyCountRangeType_values = [
  PropertyCountRangeType.ELEVEN_TO_FIFTY,
  PropertyCountRangeType.FIFTY_ONE_TO_TWO_HUNDRED,
  PropertyCountRangeType.ONE,
  PropertyCountRangeType.TWO_HUNDRED_PLUS,
  PropertyCountRangeType.TWO_TO_TEN,
] as const;
